// useVoice.ts
import { useEffect, useState, useCallback } from 'react';
import {
  startListening as rawStart,
  stopListening as rawStop,
  setTranscriptCallback,
  setErrorCallback,
  getCurrentTranscript,
  getIsListening,
} from '../services/voiceService';

export function useVoice() {
  const [transcript, setTranscript] = useState<string>('');
  const [listening, setListening] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);
  const [isTranscribing, setIsTranscribing] = useState<boolean>(false);

  useEffect(() => {
    // wire callbacks
    setTranscriptCallback((t) => setTranscript(t));
    setErrorCallback((e) => setError(e));

    // keep listening flag in sync with service
    setListening(getIsListening());
  }, []);

  const start = useCallback(async () => {
    setError(null);
    try {
      await rawStart();
      setListening(true);
    } catch (e) {
      setError(e);
      setListening(false);
    }
  }, []);

  const stop = useCallback(async () => {
    try {
      setIsTranscribing(true);  // Show loading
      await rawStop();
      setListening(false);
      // attempt to pull latest transcript from service
      setTranscript(getCurrentTranscript());
    } catch (e) {
      setError(e);
    } finally {
      setIsTranscribing(false);
    }
  }, []);

  return { transcript, listening, start, stop, error, isTranscribing };
}
